module.exports = __webpack_public_path__ + "img/bcf0bb1.jpg";